import { Box, Typography, TextField, useMediaQuery, useTheme } from '@mui/material'
import React from 'react'
import { useStyles } from '../style'
import { OptionCard } from '../components'
import useKeyboardNavigation from '../../../hooks/useKeyboardNavigation'

const CurrentRolePage = ({
  title,
  roles,
  selectedRole,
  customCurrentRole,
  onSelectRole,
  onCustomRoleChange
}) => {
  const classes = useStyles()
  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down('md'))
  const isOtherSelected = selectedRole === 'Other / not sure' || selectedRole === 'Other'

  const { focusedIndex, handleKeyDown } = useKeyboardNavigation(
    roles.length,
    isMobile ? 1 : 2,
    (index) => onSelectRole(roles[index])
  )

  return (
    <Box className={classes.content} data-test='current-role-page' onKeyDown={handleKeyDown}>
      <Typography
        id='lpq-dialog-title'
        className={classes.question}
        data-test='current-role-title'
        component='h2'
      >
        {title}
      </Typography>
      <Box
        className={classes.twoColumnGrid}
        data-test='role-options-grid'
        role='group'
        aria-label='Current role options'
      >
        {roles.map((role, index) => (
          <OptionCard
            key={role}
            text={role}
            isSelected={selectedRole === role}
            onClick={() => onSelectRole(role)}
            variant='timeRole'
            hasSelection={selectedRole !== '' || isOtherSelected}
            isFocused={focusedIndex === index}
            onKeyDown={handleKeyDown}
          />
        ))}
      </Box>
      {isOtherSelected && (
        <Box className={classes.otherInputWrapper} data-test='custom-role-input-wrapper'>
          <Typography className={classes.otherInputLabel} data-test='custom-role-label'>
            Please specify your role
          </Typography>
          <TextField
            value={customCurrentRole}
            onChange={(e) => onCustomRoleChange(e.target.value)}
            className={classes.otherInputField}
            autoFocus
            inputProps={{
              maxLength: 100,
              'aria-label': 'Enter your custom role'
            }}
            data-test='custom-role-input'
          />
        </Box>
      )}
    </Box>
  )
}

export default CurrentRolePage
